import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith("es") ? "es" : "en";

  const switchTo = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => switchTo("en")}
        className={`w-8 h-6 rounded-sm overflow-hidden border transition-all ${
          currentLang === "en" ? "border-primary ring-1 ring-primary/30" : "border-border opacity-50 hover:opacity-80"
        }`}
        aria-label="English"
        title="English"
      >
        {/* US Flag */}
        <svg viewBox="0 0 32 24" className="w-full h-full">
          <rect width="32" height="24" fill="#B22234" />
          <rect y="1.85" width="32" height="1.85" fill="#fff" />
          <rect y="5.54" width="32" height="1.85" fill="#fff" />
          <rect y="9.23" width="32" height="1.85" fill="#fff" />
          <rect y="12.92" width="32" height="1.85" fill="#fff" />
          <rect y="16.62" width="32" height="1.85" fill="#fff" />
          <rect y="20.31" width="32" height="1.85" fill="#fff" />
          <rect width="12.8" height="12.92" fill="#3C3B6E" />
        </svg>
      </button>
      <button
        onClick={() => switchTo("es")}
        className={`w-8 h-6 rounded-sm overflow-hidden border transition-all ${
          currentLang === "es" ? "border-primary ring-1 ring-primary/30" : "border-border opacity-50 hover:opacity-80"
        }`}
        aria-label="Español"
        title="Español"
      >
        {/* Mexico Flag */}
        <svg viewBox="0 0 32 24" className="w-full h-full">
          <rect width="10.67" height="24" fill="#006847" />
          <rect x="10.67" width="10.67" height="24" fill="#fff" />
          <rect x="21.33" width="10.67" height="24" fill="#CE1126" />
          <circle cx="16" cy="12" r="2.5" fill="#6B3A2A" />
        </svg>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
